import OFFLINE_ICON from '../../assets/icons/no-wifi.png';
import CHECKERED_FLAG_ICON from '../../assets/icons/checkered-flag.svg';
import CAR_CRASH_ICON from '../../assets/icons/car-crash.svg';
import ENVELOPE_ICON from '../../assets/icons/envelope.svg';
import ENVELOPE_OPEN_ICON from '../../assets/icons/envelope-open.svg';
import CAR_SEAT from '../../assets/icons/car-seat.svg';
import FUEL_PUMP from '../../assets/icons/fuel-pump.svg';
import CAR_DOOR from '../../assets/icons/car-door.svg';
import CAR_EMISSION from '../../assets/icons/car-emission.svg';
import PUBLIC_ICON from '../../assets/icons/public.svg';
import EV_STATION from '../../assets/icons/ev-station.svg';

export const iconLocations = Object.freeze({
    OFFLINE_ICON,
    CHECKERED_FLAG_ICON,
    CAR_CRASH_ICON,
    ENVELOPE_ICON,
    ENVELOPE_OPEN_ICON,
    CAR_SEAT,
    FUEL_PUMP,
    CAR_DOOR,
    CAR_EMISSION,
    PUBLIC_ICON,
    EV_STATION
});